export default (function citiesInit() {
    const cities = {
        select() {
            $('body').on('click', '.js--city', function () {
                const data = {
                    id_city_geo: $(this).data('id'),
                    submitCityId: 1,
                };
                $.ajax({
                    url: '/modules/geoipredirect/ajax.php',
                    type: 'POST',
                    dataType: 'json',
                    data,
                    success: () => {
                        window.location.reload();
                    },
                });
            });
        },
        initModal() {
            // $('.js--correct_city').appendTo('');
            setTimeout(() => {
                $('.js--correct_city').slideDown();
            }, 1000);
            $('.js--correct_city__close').click(() => $('.js--correct_city').slideUp());
            $('.js--change_city').click(() => {
                $('.js--correct_city').slideUp(() => $('.city_wrap .dropdown__button').trigger('click')); /* $().dropdown('toggle') как-то криво работал. дропдаут открывал, но потом его нельзя было закрыть */
            });
        },
    };
    $(document).ready(() => {
        // cities.initModal();
        cities.select();
    });
}());
